const Footer = () => {
    return (
        <div className="text-center" style={{
            backgroundColor: "#FF4BA6",
            height: "100px",
            width: "100%"
        }}>
        </div>
    )
}

export default Footer